// extracted by mini-css-extract-plugin
module.exports = {"nav-tab-button-container":"nav-tab-button-container-r8HUb","label":"label-mc9eB","icon":"icon-vxKmB","logo":"logo-ST06l"};